import * as z from "zod/v4";

export const createMobileUploadToken = {
  name: "createMobileUploadToken" as const,
  input: z.object({ widgetId: z.string() }),
  output: z.object({ token: z.string(), expiresAt: z.date() }),
};
